export default {
    x10: '2px',
    x20: '6px',
    x30: '8px',
    x40: '16px',
    x50: '100px',
};
